import { CandidatesReducer, InitialCandidatesState } from '../reducer';
import { CandidatesAction } from '../types';

describe('CandidatesReducer', () => {
  it('should return initial state', () => {
    const action = { type: 'UNKNOWN_ACTION' } as any;
    const newState = CandidatesReducer(InitialCandidatesState, action);
    expect(newState).toEqual(InitialCandidatesState);
  });

  describe('SET_SNACKBAR', () => {
    it('should update snackbar state', () => {
      const action: CandidatesAction = {
        type: 'SET_SNACKBAR',
        payload: {
          message: 'Test message',
          state: 'error'
        }
      };

      const newState = CandidatesReducer(InitialCandidatesState, action);

      expect(newState.snackbar).toEqual({
        message: 'Test message',
        state: 'error'
      });
    });
  });

  describe('SET_SEARCH_QUERY', () => {
    it('should update search query and reset page to 1', () => {
      const action: CandidatesAction = {
        type: 'SET_SEARCH_QUERY',
        payload: 'test search'
      };

      const newState = CandidatesReducer(InitialCandidatesState, action);

      expect(newState.searchQuery).toBe('test search');
      expect(newState.candidatesTableSettings.page).toBe(1);
    });
  });

  describe('SET_DENSITY', () => {
    it('should update table density', () => {
      const action: CandidatesAction = {
        type: 'SET_DENSITY',
        payload: 'Compact'
      };

      const newState = CandidatesReducer(InitialCandidatesState, action);

      expect(newState.candidatesTableState.density).toBe('Compact');
    });
  });

  describe('SET_CAN_SCROLL', () => {
    it('should update can scroll state', () => {
      const action: CandidatesAction = {
        type: 'SET_CAN_SCROLL',
        payload: [true, false]
      };

      const newState = CandidatesReducer(InitialCandidatesState, action);

      expect(newState.candidatesTableState.canScroll).toEqual([true, false]);
    });
  });

  describe('SET_TABLE_HOVERED', () => {
    it('should update table hovered state', () => {
      const action: CandidatesAction = {
        type: 'SET_TABLE_HOVERED',
        payload: true
      };

      const newState = CandidatesReducer(InitialCandidatesState, action);

      expect(newState.candidatesTableState.tableHovered).toBe(true);
    });
  });

  describe('SET_SORT', () => {
    it('should update sort settings', () => {
      const action: CandidatesAction = {
        type: 'SET_SORT',
        payload: {
          sortBy: 'lastname',
          sortOrder: 'desc'
        }
      };

      const newState = CandidatesReducer(InitialCandidatesState, action);

      expect(newState.candidatesTableSettings.sort).toBe('lastname');
      expect(newState.candidatesTableSettings.sort_order).toBe('desc');
    });
  });

  describe('SET_PAGE', () => {
    it('should update page number', () => {
      const action: CandidatesAction = {
        type: 'SET_PAGE',
        payload: 3
      };

      const newState = CandidatesReducer(InitialCandidatesState, action);

      expect(newState.candidatesTableSettings.page).toBe(3);
    });
  });

  describe('SET_LIMIT', () => {
    it('should update limit', () => {
      const action: CandidatesAction = {
        type: 'SET_LIMIT',
        payload: 25
      };

      const newState = CandidatesReducer(InitialCandidatesState, action);

      expect(newState.candidatesTableSettings.limit).toBe(25);
    });
  });

  describe('SELECT_ACTION_ITEM', () => {
    it('should update selected item and open action', () => {
      const mockItem = {
        id: 1,
        firstname: 'John',
        lastname: 'Doe',
        email: 'john@example.com',
        number_of_applications: 1,
        employee_id: null,
        duplicated_candidates: [],
        existing_candidate: false,
        gender_full: 'Male',
        updated_at: '2023-01-01T00:00:00Z',
        linkedin_url: null,
        phone1: '1234567890',
        phone2: '',
        address: '123 Main St',
        tag_list: [],
        entity_tags: [],
        address_details: {
          country: null,
          state: null,
          id: 1,
          postcode: '12345',
          street1: '123 Main St',
          street2: null,
          street_number: '123',
          street_type: 'St',
          suburb: 'Test City'
        },
        notepad: null,
        title: 'Software Engineer'
      };

      const action: CandidatesAction = {
        type: 'SELECT_ACTION_ITEM',
        payload: {
          item: mockItem,
          anchorEl: document.createElement('div'),
          name: 'edit'
        }
      };

      const newState = CandidatesReducer(InitialCandidatesState, action);

      expect(newState.candidatesTableState.actions.selectedItem).toEqual(mockItem);
      expect(newState.candidatesTableState.actions.isOpen.edit).toBe(true);
      expect(newState.candidatesTableState.actions.anchorEl).toBeDefined();
    });
  });

  describe('ADD_SELECTED_ITEM', () => {
    it('should add item to selected items', () => {
      const mockItem = {
        id: 1,
        firstname: 'John',
        lastname: 'Doe',
        email: 'john@example.com',
        number_of_applications: 1,
        employee_id: null,
        duplicated_candidates: [],
        existing_candidate: false,
        gender_full: 'Male',
        updated_at: '2023-01-01T00:00:00Z',
        linkedin_url: null,
        phone1: '1234567890',
        phone2: '',
        address: '123 Main St',
        tag_list: [],
        entity_tags: [],
        address_details: {
          country: null,
          state: null,
          id: 1,
          postcode: '12345',
          street1: '123 Main St',
          street2: null,
          street_number: '123',
          street_type: 'St',
          suburb: 'Test City'
        },
        notepad: null,
        title: 'Software Engineer'
      };

      const action: CandidatesAction = {
        type: 'ADD_SELECTED_ITEM',
        payload: mockItem
      };

      const newState = CandidatesReducer(InitialCandidatesState, action);

      expect(newState.candidatesTableState.selectedItems).toContain(mockItem);
      expect(newState.candidatesTableState.selectedItemIds).toContain(1);
    });
  });

  describe('REMOVE_SELECTED_ITEM', () => {
    it('should remove item from selected items', () => {
      const mockItem = {
        id: 1,
        firstname: 'John',
        lastname: 'Doe',
        email: 'john@example.com',
        number_of_applications: 1,
        employee_id: null,
        duplicated_candidates: [],
        existing_candidate: false,
        gender_full: 'Male',
        updated_at: '2023-01-01T00:00:00Z',
        linkedin_url: null,
        phone1: '1234567890',
        phone2: '',
        address: '123 Main St',
        tag_list: [],
        entity_tags: [],
        address_details: {
          country: null,
          state: null,
          id: 1,
          postcode: '12345',
          street1: '123 Main St',
          street2: null,
          street_number: '123',
          street_type: 'St',
          suburb: 'Test City'
        },
        notepad: null,
        title: 'Software Engineer'
      };

      // First add the item
      const addAction: CandidatesAction = {
        type: 'ADD_SELECTED_ITEM',
        payload: mockItem
      };
      let state = CandidatesReducer(InitialCandidatesState, addAction);

      // Then remove it
      const removeAction: CandidatesAction = {
        type: 'REMOVE_SELECTED_ITEM',
        payload: mockItem.id
      };
      const newState = CandidatesReducer(state, removeAction);

      expect(newState.candidatesTableState.selectedItems).not.toContain(mockItem);
      expect(newState.candidatesTableState.selectedItemIds).not.toContain(1);
    });
  });

  describe('ADD_ALL_PAGE_ITEMS', () => {
    it('should add all page items to selected items', () => {
      const mockItems = [
        {
          id: 1,
          firstname: 'John',
          lastname: 'Doe',
          email: 'john@example.com',
          number_of_applications: 1,
          employee_id: null,
          duplicated_candidates: [],
          existing_candidate: false,
          gender_full: 'Male',
          updated_at: '2023-01-01T00:00:00Z',
          linkedin_url: null,
          phone1: '1234567890',
          phone2: '',
          address: '123 Main St',
          tag_list: [],
          entity_tags: [],
          address_details: {
            country: null,
            state: null,
            id: 1,
            postcode: '12345',
            street1: '123 Main St',
            street2: null,
            street_number: '123',
            street_type: 'St',
            suburb: 'Test City'
          },
          notepad: null,
          title: 'Software Engineer'
        },
        {
          id: 2,
          firstname: 'Jane',
          lastname: 'Smith',
          email: 'jane@example.com',
          number_of_applications: 2,
          employee_id: 'EMP001',
          duplicated_candidates: [],
          existing_candidate: true,
          gender_full: 'Female',
          updated_at: '2023-01-02T00:00:00Z',
          linkedin_url: 'https://linkedin.com/in/janesmith',
          phone1: '0987654321',
          phone2: '',
          address: '456 Oak Ave',
          tag_list: ['experienced'],
          entity_tags: [{ value: 'senior', label: 'Senior' }],
          address_details: {
            country: { id: 1, name: 'Australia', iso: 'AU' },
            state: { id: 1, name: 'NSW' },
            id: 2,
            postcode: '2000',
            street1: '456 Oak Ave',
            street2: null,
            street_number: '456',
            street_type: 'Ave',
            suburb: 'Sydney'
          },
          notepad: { body: 'Great candidate' },
          title: 'Senior Developer'
        }
      ];

      const action: CandidatesAction = {
        type: 'ADD_ALL_PAGE_ITEMS',
        payload: mockItems
      };

      const newState = CandidatesReducer(InitialCandidatesState, action);

      expect(newState.candidatesTableState.selectedItems).toEqual(mockItems);
      expect(newState.candidatesTableState.selectedItemIds).toEqual([1, 2]);
    });
  });

  describe('REMOVE_ALL_PAGE_ITEMS', () => {
    it('should remove all selected items', () => {
      const mockItems = [
        {
          id: 1,
          firstname: 'John',
          lastname: 'Doe',
          email: 'john@example.com',
          number_of_applications: 1,
          employee_id: null,
          duplicated_candidates: [],
          existing_candidate: false,
          gender_full: 'Male',
          updated_at: '2023-01-01T00:00:00Z',
          linkedin_url: null,
          phone1: '1234567890',
          phone2: '',
          address: '123 Main St',
          tag_list: [],
          entity_tags: [],
          address_details: {
            country: null,
            state: null,
            id: 1,
            postcode: '12345',
            street1: '123 Main St',
            street2: null,
            street_number: '123',
            street_type: 'St',
            suburb: 'Test City'
          },
          notepad: null,
          title: 'Software Engineer'
        }
      ];

      // First add items
      const addAction: CandidatesAction = {
        type: 'ADD_ALL_PAGE_ITEMS',
        payload: mockItems
      };
      let state = CandidatesReducer(InitialCandidatesState, addAction);

      // Then remove all
      const removeAction: CandidatesAction = {
        type: 'REMOVE_ALL_PAGE_ITEMS',
        payload: mockItems
      };
      const newState = CandidatesReducer(state, removeAction);

      expect(newState.candidatesTableState.selectedItems).toEqual([]);
      expect(newState.candidatesTableState.selectedItemIds).toEqual([]);
    });
  });

  describe('CLOSE_ACTION_ITEM', () => {
    it('should close action item and reset selected item', () => {
      const mockItem = {
        id: 1,
        firstname: 'John',
        lastname: 'Doe',
        email: 'john@example.com',
        number_of_applications: 1,
        employee_id: null,
        duplicated_candidates: [],
        existing_candidate: false,
        gender_full: 'Male',
        updated_at: '2023-01-01T00:00:00Z',
        linkedin_url: null,
        phone1: '1234567890',
        phone2: '',
        address: '123 Main St',
        tag_list: [],
        entity_tags: [],
        address_details: {
          country: null,
          state: null,
          id: 1,
          postcode: '12345',
          street1: '123 Main St',
          street2: null,
          street_number: '123',
          street_type: 'St',
          suburb: 'Test City'
        },
        notepad: null,
        title: 'Software Engineer'
      };

      // First select an item
      const selectAction: CandidatesAction = {
        type: 'SELECT_ACTION_ITEM',
        payload: {
          item: mockItem,
          anchorEl: document.createElement('div'),
          name: 'edit'
        }
      };
      let state = CandidatesReducer(InitialCandidatesState, selectAction);

      // Then close it
      const closeAction: CandidatesAction = {
        type: 'CLOSE_ACTION_ITEM',
        payload: 'edit'
      };
      const newState = CandidatesReducer(state, closeAction);

      expect(newState.candidatesTableState.actions.selectedItem).toBeNull();
      expect(newState.candidatesTableState.actions.isOpen.edit).toBe(false);
      expect(newState.candidatesTableState.actions.anchorEl).toBeNull();
    });
  });
});
